import ReactECharts from "echarts-for-react";

const Humidity = ({ value = 0 }: { value: number }) => {

    const labelSetting = {
        show: false,
        position: 'top',
        offset: [0, 0],
        formatter: function (param: { value: number }) {
            return ((param.value / 100) * 100).toFixed(0) + '%';
        },
        fontSize: 18,
        fontFamily: 'Arial'
    };

    const option = {
        xAxis: {
            data: ['Humidity', 'Humidity', 'Humidity', 'Humidity', 'Humidity'],
            axisTick: { show: false },
            axisLine: { show: false },
            axisLabel: { show: false }
        },
        yAxis: {
            max: 100,
            offset: 20,
            splitLine: { show: false }
        },
        grid: {
            top: 'center',
            height: 100
        },
        markLine: {
            z: -100
        },
        series: [
            {
                name: 'Humidity',
                type: 'pictorialBar',
                symbolClip: true,
                symbolBoundingData: 100,
                label: labelSetting,
                data: [
                    {
                        value: value,
                        symbol: "BAR",
                    },
                    {
                        value: value,
                        symbol: "BAR"
                    },
                    {
                        value: value,
                        symbol: "BAR"
                    },
                    {
                        value: value,
                        symbol: "BAR"
                    },
                    {
                        value: value,
                        symbol: "BAR"
                    }
                ],
                z: 10
            },

            {
                name: 'full',
                type: 'pictorialBar',
                symbolBoundingData: 100,
                animationDuration: 0,

                itemStyle: {
                    color: '#ccc'
                },
                data: [
                    {
                        value: 1,
                        symbol: "BAR"
                    },
                    {
                        value: 1,
                        symbol: "BAR"
                    },
                    {
                        value: 1,
                        symbol: "BAR"
                    },
                    {
                        value: 1,
                        symbol: "BAR"
                    },
                    {
                        value: 1,
                        symbol: "BAR"
                    }
                ]
            }
        ]
    };



    return <ReactECharts option={option} style={{ height: 100, width: 270 }} />
};

export { Humidity };